import * as types from './types';
import initialState from './initial-state';

export default function adsStudioReducer(state = initialState, action) {
  switch (action.type) {
    case types.SET_CAMPAIGNS:
      return { ...state, campaigns: action.payload };

    case types.SET_LOADING:
      return { ...state, loading: action.payload };

    case types.SET_SAVING:
      return { ...state, saving: action.payload };

    case types.SET_GENERATING_COPY:
      return { ...state, generatingCopy: action.payload };

    case types.SET_COPY_VARIANTS:
      return { ...state, copyVariants: action.payload };

    case types.SET_GENERATION_ID:
      return { ...state, generationId: action.payload };

    case types.SET_ERROR:
      return { ...state, error: action.payload };

    case types.ADD_CAMPAIGN:
      return { ...state, campaigns: [action.payload, ...state.campaigns] };

    case types.UPDATE_CAMPAIGN:
      return {
        ...state,
        campaigns: state.campaigns.map((c) =>
          c.id === action.payload.id ? action.payload : c
        ),
      };

    case types.REMOVE_CAMPAIGN:
      return {
        ...state,
        campaigns: state.campaigns.filter((c) => c.id !== action.payload),
      };

    default:
      return state;
  }
}
